import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.group.request');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcuser-group-request',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.group.request/view.scss */
/* src/app/portal.gsdcuser.group.request/view.scss: no such file or directory */`],
})
export class PortalGsdcuserGroupRequestComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) { }
    private destroyed = false;
    ngOnDestroy() { this.destroyed = true; }
    public activeTab = 'signup';
    public role = '';
    public community_id = '';
    public isIndividualResearcher = false;
    public isLoaded = false;
    public loadFailed = false;
    public loading = false;
    public get canViewSignup() {
        return !this.isIndividualResearcher || this.role === 'manager' || this.role === 'admin';
    }
    async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        this.role = this.service.auth.session.role;
        this.community_id = this.service.auth.session.community_id;
        await this.loadContext();
    }
    public async loadContext() {
        if (this.loading) return;
        this.loading = true;
        this.loadFailed = false;
        this.isLoaded = false;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("check_individual_researcher",
                { user_id: this.service.auth.session.id }, { timeout: 15000 });
            if (this.destroyed) return;
            if (code !== 200 || typeof data !== 'boolean') throw new Error('load');
            this.isIndividualResearcher = data;
            const requested = new URL(window.location.href).searchParams.get('tab');
            const allowed = this.canViewSignup ? ['signup', 'newGroup', 'joinGroup'] : ['newGroup', 'joinGroup'];
            this.setTab(allowed.includes(requested) ? requested : allowed[0]);
            this.isLoaded = true;
        } catch (_) {
            this.loadFailed = true;
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }
    public setTab(tab: string) {
        if (!['signup', 'newGroup', 'joinGroup'].includes(tab) || (tab === 'signup' && !this.canViewSignup)) return;
        this.activeTab = tab;
        const url = new URL(window.location.href);
        url.searchParams.set('tab', tab);
        window.history.replaceState(window.history.state, '', url);
    }
}

export default PortalGsdcuserGroupRequestComponent;